import pb from '../lib/pb';

// Bygg thumb-URL oavsett om record saknar @collectionName/@collectionId
export function fileThumbUrl(rec: any, fileName?: string) {
  if (!fileName) return '';
  try {
    if (rec?.['@collectionName'] || rec?.collectionName || rec?.['@collectionId'] || rec?.collectionId) {
      return pb.files.getUrl(rec, fileName, { thumb: '128x128' });
    }
  } catch {}
  const base = pb.baseUrl.replace(/\/+$/, '');
  return `${base}/api/files/sprites/${rec.id}/${encodeURIComponent(fileName)}?thumb=128x128`;
}